import apiClient from './client';

export interface LoginResponse {
  accessToken: string;
  user: {
    id: string;
    username: string;
    name?: string | null;
    phone?: string | null;
    avatarUrl?: string | null;
    role: string;
    requirePasswordChange?: boolean;
    createdAt?: string;
  };
}

export interface MeResponse {
  id: string;
  username: string;
  name: string | null;
  phone: string | null;
  avatarUrl: string | null;
  role: string;
  requirePasswordChange: boolean;
  createdAt: string;
}

export interface ProfileUpdatePayload {
  name?: string;
  phone?: string;
  avatarUrl?: string | null;
}

export const authApi = {
  login: (username: string, password: string) =>
    apiClient.post<LoginResponse>('/auth/login', { username, password }),

  register: (data: {
    username: string;
    password: string;
    name: string;
    phone: string;
    role?: string;
  }) => apiClient.post('/auth/register', data),

  me: () => apiClient.get<MeResponse>('/auth/me'),

  updateProfile: (data: ProfileUpdatePayload) => apiClient.patch<MeResponse>('/auth/me', data),

  uploadAvatar: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post<{ avatarUrl: string }>('/auth/me/avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  deleteAvatar: () => apiClient.delete<{ avatarUrl: null }>('/auth/me/avatar'),

  changePassword: (currentPassword: string, newPassword: string) =>
    apiClient.post('/auth/change-password', { currentPassword, newPassword }),
};
